module.exports = __webpack_public_path__ + "static/klee-banner-b0e78ce198c0e7769f9d5b63ef23369d.png";